import fetch from './fetch';

// 系统管理-角色管理
const role = ({ params, methold }) => fetch({ url: '/role', params, methold });
const controlRole = ({ params, id, methold }) => fetch({ url: `/role/${id}`, params, methold });
const getRoleUsers = ({ params, id }) => fetch({ url: `/role/${id}/users`, params });
const queryRoleUsers = ({ params, id }) => fetch({ url: `/role/${id}/users/query`, params });
const addRoleUser = ({ params, id }) => fetch({ url: `/role/${id}/users/add`, params, methold: 'post' });
const removeRoleUser = ({ params, id }) => fetch({ url: `/role/${id}/users/remove`, params, methold: 'post' });
const getRolePermissions = ({ params, id }) => fetch({ url: `/role/${id}/permissions`, params });
const upgradeRolePermissions = ({ params, id }) =>
  fetch({ url: `/role/${id}/permissions/upgrade`, params, methold: 'post' });

// 系统管理-消息管理
const getSysMsg = params => fetch({ url: '/sys_msg', params });
const addSysMsg = ({ params }) => fetch({ url: '/sys_msg', params, methold: 'post' });
const delSysMsg = ({ params, methold, msg_id }) => fetch({ url: `/sys_msg/${msg_id}`, params, methold });
const readAllMsg = () => fetch({ url: '/read_all_msg', methold: 'post' });

// 系统管理-成员管理
const user = ({ params }) => fetch({ url: '/user', params, methold: 'post' });
const getUserList = params => fetch({ url: '/user', params });
const controlUser = ({ params, id, methold }) => fetch({ url: `/user/${id}`, params, methold });
const userActivate = ({ id }) => fetch({ url: `/user/${id}/activate`, methold: 'patch' });
const userDeactivate = ({ id }) => fetch({ url: `/user/${id}/deactivate`, methold: 'patch' });
const userRoleList = ({ id }) => fetch({ url: `/user/${id}/user_role/list` });
const userRoleQuery = ({ id }) => fetch({ url: `/user/${id}/user_role/query` });
const userRoleListAdd = ({ id, params }) => fetch({ url: `/user/${id}/user_role/add`, params, methold: 'post' });
const userRoleListAddAll = ({ id, params }) => fetch({ url: `/user/${id}/set_all_roles`, params, methold: 'post' });
const userRoleListRemove = ({ id, params }) => fetch({ url: `/user/${id}/user_role/remove`, params, methold: 'post' });
const userRoleListChoose = ({ id }) => fetch({ url: `/user/${id}/user_role/choose` });
const userRoleRemoveAll = ({ id }) => fetch({ url: `/user/${id}/remove_all_roles`, methold: 'post' });

const userRoleSubList = ({ id }) => fetch({ url: `/user/${id}/user_specialized_subject/list` });
const userRoleSubQuery = params => fetch({ url: `/user/${params.id}/user_specialized_subject/query`, params });
const userRoleSubUpdate = ({ id, params }) =>
  fetch({ url: `/user/${id}/user_specialized_subject/upgrade`, params, methold: 'post' });
const userRoleSubRemove = ({ id, params }) =>
  fetch({ url: `/user/${id}/user_specialized_subject/remove`, params, methold: 'post' });
const userRoleSubSetAll = ({ id, params }) =>
  fetch({ url: `/user/${id}/set_all_specialized_subject`, params, methold: 'post' });
const userRoleSubRemoveAll = ({ id, params }) =>
  fetch({ url: `/user/${id}/remove_all_specialized_subject`, params, methold: 'post' });

const userRoleSubFullList = ({ id, params }) =>
  fetch({ url: `/user/${id}/user_specialized_subject/full_list`, params, methold: 'post' });
const userOrgEditList = ({ id }) => fetch({ url: `/user/${id}/user_org/query` });
const userOrgList = ({ id }) => fetch({ url: `/user/${id}/user_org/list` });
const userOrgListUpgrade = ({ id, params }) => fetch({ url: `/user/${id}/user_org/upgrade`, params, methold: 'post' });
const userOrgListRemove = ({ id, params }) => fetch({ url: `/user/${id}/user_org/remove`, params, methold: 'post' });

const userChangePassword = ({ id, params }) => fetch({ url: `/user/${id}/change_password`, params, methold: 'post' });

const userJobChoose = () => fetch({ url: '/job_choose' });
const userGenderChoose = () => fetch({ url: '/gender_choose' });
const userRelation = () => fetch({ url: '/relation' });

// 注册用户信息
const registerUser = ({ params, methold }) => fetch({ url: '/register_user', params, methold });
const getrRegisterUser = params => fetch({ url: '/register_user', params });
const controlRegisterUser = ({ id, params, methold }) => fetch({ url: `/register_user/${id}`, params, methold });
const getIdCardType = params => fetch({ url: '/id_card_type', params });
const resetPassword = ({ params, id }) => fetch({ url: `/reset_password/${id}`, params, methold: 'put' });

const getRegisterUserRelation = ({ id, params }) => fetch({ url: `/register_user/${id}/contact`, params });
const addRegisterUserRelation = ({ id, params }) =>
  fetch({ url: `/register_user/${id}/contact`, params, methold: 'post' });
const controlRegisterUserRelation = ({ id, params, methold }) => fetch({ url: `/contact/${id}`, params, methold });
const gradeChoose = () => fetch({ url: '/grade_choose' });
const getContact = params => fetch({ url: '/contact', params });
const passContact = ({ contact_id }) => fetch({ url: `/pass_contact_audit/${contact_id}`, methold: 'patch' });
const rejectContact = ({ contact_id }) => fetch({ url: `/reject_contact_audit/${contact_id}`, methold: 'patch' });

// 假日管理
const getHoliday = params => fetch({ url: '/holiday', params });
const holiday = ({ params, methold }) => fetch({ url: '/holiday', params, methold });
const controlHoliday = ({ params, methold, id }) => fetch({ url: `/holiday/${id}`, params, methold });

// 全局设置
const globalConfig = ({ params, methold }) => fetch({ url: '/global_config', params, methold });

// 个人信息修改密码
const changePassword = ({ params }) => fetch({ url: '/change_password', params, methold: 'post' });
// 个人信息修改手机号
const changePhone = ({ params, methold }) =>
  fetch({
    url: '/verify_old_phone_number',
    params,
    methold,
    config: { responseType: 'blob' }
  });
const changeNewPhone = ({ params, methold }) =>
  fetch({
    url: '/modify_mobile_number',
    params,
    methold,
    config: { responseType: 'blob' }
  });
const discountReasonQueryAll = () => fetch({ url: '/discount_reason_query' });
const perisonDisCounts = ({ id }) => fetch({ url: `/user/${id}/get_discount_reason` });
const setDisCounts = ({ params, id }) => fetch({ url: `/user/${id}/set_discount_reason`, params, methold: 'post' });
const setDisCountAll = ({ id }) => fetch({ url: `/user/${id}/set_all_discount_reason`, methold: 'post' });
const exportRegister = ({ params }) =>
  fetch({
    url: '/export_register_user_list',
    isFull: true,
    params,
    config: { responseType: 'blob' }
  });
const exportContact = ({ params }) =>
  fetch({
    url: '/export_contact',
    isFull: true,
    params,
    config: { responseType: 'blob' }
  });
// 全局设置
const gUpdateBanner = ({ params }) => fetch({ url: '/global_config/update_class_banner', params, methold: 'post' });
const gCancelRe = ({ params }) => fetch({ url: '/global_config/cancel_recommend', params, methold: 'post' });
const gClassBannerList = ({ params }) => fetch({ url: '/global_config/class_banner_list', params });

// 数据权限
const dataPermissionType = () => fetch({ url: '/data_permission_type_select' });
const addRoleDataPermission = ({ params }) => fetch({ url: '/add_role_data_permission', params, methold: 'post' });
const getDataPermission = ({ params }) => fetch({ url: '/get_data_permission', params });

export default {
  resetPassword,
  getDataPermission,
  addRoleDataPermission,
  dataPermissionType,
  addSysMsg,
  getSysMsg,
  delSysMsg,
  readAllMsg,
  rejectContact,
  passContact,
  getContact,
  exportRegister,
  role,
  controlRole,
  getRoleUsers,
  queryRoleUsers,
  addRoleUser,
  removeRoleUser,
  getRolePermissions,
  upgradeRolePermissions,
  user,
  getUserList,
  controlUser,
  userActivate,
  userDeactivate,
  userRoleList,
  userRoleQuery,
  userRoleListAdd,
  userRoleListAddAll,
  userRoleListRemove,
  userRoleListChoose,
  userRoleRemoveAll,
  userRoleSubList,
  userRoleSubQuery,
  userRoleSubUpdate,
  userRoleSubRemove,
  userOrgList,
  userOrgEditList,
  userOrgListUpgrade,
  userOrgListRemove,
  userRoleSubFullList,
  userJobChoose,
  userGenderChoose,
  userRoleSubSetAll,
  userRoleSubRemoveAll,
  userChangePassword,
  registerUser,
  getrRegisterUser,
  controlRegisterUser,
  getIdCardType,
  userRelation,
  getRegisterUserRelation,
  addRegisterUserRelation,
  controlRegisterUserRelation,
  getHoliday,
  holiday,
  controlHoliday,
  globalConfig,
  changePassword,
  changePhone,
  changeNewPhone,
  gradeChoose,
  perisonDisCounts,
  setDisCounts,
  setDisCountAll,
  discountReasonQueryAll,
  gUpdateBanner,
  gCancelRe,
  gClassBannerList,
  exportContact
};
